<template>
  <div class="w-full">
    <div class="bg-white">
      <div class="rounded-lg shadow-sm border border-gray-200">
        <div v-if="hasDeliveryAddresses" class="pt-4 pb-2 px-6 max-h-72 overflow-y-auto">
          <fieldset>
            <div class="leading-5">
              <DeliveryAddressRow
                v-for="deliveryAddress in deliveryAddresses"
                :key="deliveryAddress.id"
                :delivery-address="deliveryAddress"
                :is-loading="isLoading"
                :can-edit="canEdit"
                :can-delete="canDelete"
                @edit-address="editDeliveryAddress"
                @remove-address="removeDeliveryAddress"
              />
            </div>
          </fieldset>
        </div>
        <div v-else class="pt-4 pb-2 px-6 text-left text-gray-500">
          <p class="text-sm">{{ canAdd ? 'No delivery addresses yet. Add one below.' : 'No delivery addresses' }}</p>
        </div>
        <AddDeliveryAddressForm
          :passed-delivery-address="selectedDeliveryAddressForEdit"
          :force-open="false"
          :conversation-user-pair-id="conversationUserPairId"
          :can-add="canAdd"
          :can-edit="canEdit"
          @delivery-address-saved="onDeliveryAddressSaved"
          @delivery-address-edit-canceled="onDeliveryAddressEditCanceled"
        />
      </div>
    </div>
  </div>
</template>

<script>
import DeliveryAddressRow from './DeliveryAddressRow.vue'
import AddDeliveryAddressForm from './AddDeliveryAddressForm.vue'
import api from '@/store/api'

export default {
  name: 'DeliveryAddressesSection',
  components: {
    DeliveryAddressRow,
    AddDeliveryAddressForm
  },
  props: {
    deliveryAddresses: {
      type: Array,
      required: true,
      default: () => []
    },
    conversationUserPairId: {
      type: [String, Number],
      required: true
    },
    canEdit: {
      type: Boolean,
      default: false
    },
    canAdd: {
      type: Boolean,
      default: false
    },
    canDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedDeliveryAddressForEdit: null,
      isLoading: false
    }
  },
  computed: {
    hasDeliveryAddresses() {
      return this.deliveryAddresses && this.deliveryAddresses.length > 0
    }
  },
  methods: {
    editDeliveryAddress(deliveryAddress) {
      this.selectedDeliveryAddressForEdit = deliveryAddress
    },
    removeDeliveryAddress(deliveryAddress) {
      if (confirm('Are you sure you want to remove this delivery address?')) {
        this.isLoading = true
        api
          .call(
            'DELETE',
            `conversation_user_pairs/${this.conversationUserPairId}/customer/delivery_address/${deliveryAddress.id}`
          )
          .then(() => {
            this.isLoading = false
            this.$emit('address-removed')
          })
          .catch(() => {
            this.isLoading = false
          })
      }
    },
    onDeliveryAddressSaved() {
      this.selectedDeliveryAddressForEdit = null
      this.$emit('address-saved')
    },
    onDeliveryAddressEditCanceled() {
      this.selectedDeliveryAddressForEdit = null
    }
  }
}
</script>
